import { useMutation } from "react-query";
import { updateSlideById } from "../services/SlideApi";

const useUpdateSlide = () => {
    return useMutation(updateSlideById)
}
 
export default useUpdateSlide;